export function stringifyParams(params: Record<string, unknown>, options?: { encode?: boolean }): string {
    const encode = options?.encode ?? true;

    return Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null)
        .flatMap(([k, v]) => {
            if (Array.isArray(v)) {
                return v
                    .filter((item) => item !== undefined && item !== null)
                    .map((item) => {
                        const value = String(item);
                        return `${k}=${encode ? encodeURIComponent(value) : value}`;
                    });
            }
            const value = String(v);
            return [`${k}=${encode ? encodeURIComponent(value) : value}`];
        })
        .join("&");
}
